// var $ = require('jquery')

// This is your plugin object. It can be exported to be used anywhere.
const MyI18NLoader = {

  name: 'I18N',
  install (Vue) {
    // We call Vue.mixin() here to inject functionality into all components.
    // var cmp = this
    Vue.i18n.add('de', this.data.translationsDe)
    Vue.i18n.add('en', this.data.translationsEn)
    Vue.i18n.set('de')
    /*
    if (Vue.config.I18N_LOAD) {
      console.log('Load i18n ' + Vue.config.I18N_APP_NAME)
      $.getJSON(Vue.config.host + '/I18N/export/' + Vue.config.I18N_APP_NAME, function (data) {
        Vue.i18n.add('de', data.localeDE)
        Vue.i18n.add('en', data.localeEN)
        Vue.i18n.set('de')
        if (cmp.starter) {
          cmp.starter()
        }
      })
    }
    */

    // set the start locale to use
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted () {
      }
    })
  },
  data: {
    'translationsDe': {
      'loginParticipantNameLabel': 'PIN',
      'loginParticipantPasswordLabel': 'TAN',
      'logInTitle': 'Examenis 2019',
      'BUTT_NAV_BACK': 'zurück',
      'loginUserNameLabel': 'Username',
      'loginPasswordLabel': 'Passwort',
      'loginSubmit': 'Anmelden',
      'Login.versionTitle': 'Version',
      'Login.version': '1.0',
      'AllowMyItemsToOpen': 'Darf eigene Fragen öffnen',
      'accountTitleLogin': 'Username',
      'LABEL_FIRSTNAME': 'Vorname',
      'LABEL_EMAIL': 'E-Mail'
    },
    'translationsEn': {
    }
  }
}
export default MyI18NLoader
